import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import Logo from "../../../components/Logo/Logo";

const Navbar = () => {
  const navigation = [
    { text: "Use cases", link: "#use-cases" },
    { text: "Demo", link: "#demo" },
    {
      text: "Book a call",
      link: "https://calendly.com/support-ene/introductory-call",
    },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/95 shadow-sm shadow-slate-200/50 backdrop-blur-md">
      <nav className="container mx-auto flex flex-wrap items-center justify-between gap-4 px-4 py-4 lg:px-8 xl:px-0">
        <div className="flex flex-wrap items-center justify-between w-full lg:w-auto">
          <NavLink
            to="/"
            className="group flex items-center gap-2 transition opacity-90 hover:opacity-100 no-underline text-xl"
          >
            <Logo />
          </NavLink>

          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  aria-label="Toggle menu"
                  className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 hover:text-slate-900 lg:hidden"
                >
                  {open ? (
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </Disclosure.Button>

                <Disclosure.Panel className="flex flex-col gap-1 py-4 lg:hidden">
                  {navigation.map((item) => (
                    <a
                      key={item.text}
                      href={item.link}
                      className="rounded-lg px-4 py-2.5 text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                    >
                      {item.text}
                    </a>
                  ))}
                  <NavLink
                    to="/login"
                    className="rounded-lg px-4 py-2.5 text-slate-600 hover:bg-slate-100 lg:ml-0"
                  >
                    Log in
                  </NavLink>
                  <NavLink
                    to="/signup"
                    className="mx-4 mt-2 flex justify-center rounded-lg bg-emerald-600 px-4 py-2.5 font-medium text-white hover:bg-emerald-700"
                  >
                    Get started
                  </NavLink>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>

        <div className="hidden items-center gap-1 lg:flex">
          {navigation.map((item) => (
            <a
              key={item.text}
              href={item.link}
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
            >
              {item.text}
            </a>
          ))}
          <NavLink
            to="/login"
            className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
          >
            Log in
          </NavLink>
          <NavLink
            to="/signup"
            className="ml-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-emerald-700"
          >
            Get started
          </NavLink>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
